__turbopack_context__.v({
  "helios-carousel": "puTB_q_helios-carousel",
  "helios-carousel--caption-below": "puTB_q_helios-carousel--caption-below",
  "helios-carousel--caption-bottom": "puTB_q_helios-carousel--caption-bottom",
  "helios-carousel--caption-title-band": "puTB_q_helios-carousel--caption-title-band",
  "helios-carousel--caption-title-section": "puTB_q_helios-carousel--caption-title-section",
  "helios-carousel--card": "puTB_q_helios-carousel--card",
  "helios-carousel--controls-below": "puTB_q_helios-carousel--controls-below",
  "helios-carousel--dots": "puTB_q_helios-carousel--dots",
  "helios-carousel--hero": "puTB_q_helios-carousel--hero",
  "helios-carousel--radius-hero": "puTB_q_helios-carousel--radius-hero",
  "helios-carousel--size-compact": "puTB_q_helios-carousel--size-compact",
  "helios-carousel--strip": "puTB_q_helios-carousel--strip",
  "helios-carousel--wide": "puTB_q_helios-carousel--wide",
  "helios-carousel-dot-fill": "puTB_q_helios-carousel-dot-fill",
  "helios-carousel__below": "puTB_q_helios-carousel__below",
  "helios-carousel__caption": "puTB_q_helios-carousel__caption",
  "helios-carousel__caption-actions": "puTB_q_helios-carousel__caption-actions",
  "helios-carousel__caption-block": "puTB_q_helios-carousel__caption-block",
  "helios-carousel__caption-description": "puTB_q_helios-carousel__caption-description",
  "helios-carousel__caption-title": "puTB_q_helios-carousel__caption-title",
  "helios-carousel__captions": "puTB_q_helios-carousel__captions",
  "helios-carousel__control": "puTB_q_helios-carousel__control",
  "helios-carousel__control--next": "puTB_q_helios-carousel__control--next",
  "helios-carousel__control--previous": "puTB_q_helios-carousel__control--previous",
  "helios-carousel__controls": "puTB_q_helios-carousel__controls",
  "helios-carousel__dot": "puTB_q_helios-carousel__dot",
  "helios-carousel__dot-fill": "puTB_q_helios-carousel__dot-fill",
  "helios-carousel__dot-mark": "puTB_q_helios-carousel__dot-mark",
  "helios-carousel__dots": "puTB_q_helios-carousel__dots",
  "helios-carousel__icon": "puTB_q_helios-carousel__icon",
  "helios-carousel__indicator": "puTB_q_helios-carousel__indicator",
  "helios-carousel__live": "puTB_q_helios-carousel__live",
  "helios-carousel__meta": "puTB_q_helios-carousel__meta",
  "helios-carousel__overlay": "puTB_q_helios-carousel__overlay",
  "helios-carousel__slide": "puTB_q_helios-carousel__slide",
  "helios-carousel__track": "puTB_q_helios-carousel__track",
  "helios-carousel__viewport": "puTB_q_helios-carousel__viewport",
});
